import { makeStyles } from "@material-ui/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { blue, pink } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
    selectBox: {
        height: "39px !important",
        display: "flex",
        alignItems: "center",
        backgroundColor: 'white',
        'text-align': 'center',
        'color': "black",
        'width': '150px !important',
        'font-family': "Roboto",
        'font-size': '12px',
        'font-weight': 'normal',
        'font-stretch': 'normal',
        'font-style': 'normal',
        'line-height': '1.17',
        'letter-spacing': 'normal',

        borderBottom: 0,
        " & :before": {
          borderBottom: 0,
        },
        " & :hover": {
          border: "none",
          borderBottom: 0,
        },
        [theme.breakpoints.down("xs")]: {
          width: "auto",
        },
      },
    selectEmpty: {
        marginTop: theme.spacing(2),
      },
      
    formControl: {
        margin: theme.spacing(1),
        minWidth: 150,
        marginRight: 0,
        [theme.breakpoints.down("xs")]: {
          display: "inline-block",
          width: "auto",
        },
      },

      
    
}));
